// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36lsG","content":"styles_content__1dknA"};